import React, {Component, Fragment, useState} from "react";
import {AtlassianNavigation, CustomProductHome, generateTheme, Profile, SignIn} from "@atlaskit/atlassian-navigation";
import smallIconURL from "./images/gq.png"
import largeIconURL from "./images/gq.png"
import {DropdownItem, DropdownItemGroup} from '@atlaskit/dropdown-menu';
import Popup from '@atlaskit/popup';
import "./styles.css";

export default class TopNavigationComponent extends Component {
    profileOptions = () => (
        <Fragment>
            <DropdownItemGroup title={this.props.accountName}>
                <DropdownItem onClick={this.props.handleLogoutAuth}>Logout</DropdownItem>
            </DropdownItemGroup>
        </Fragment>
    );

    userProfile = () => {
        const [isOpen, setIsOpen] = useState(false);

        const onClick = () => {
            setIsOpen(!isOpen);
        };

        const onClose = () => {
            setIsOpen(false);
        };

        return (
            <Popup
                placement="bottom-start"
                content={this.profileOptions}
                isOpen={isOpen}
                onClose={onClose}
                trigger={triggerProps => (
                    <Profile
                        icon={<img
                            style={{ borderRadius: '100%', width: 24, height: 24 }}
                            src={this.props.avatarURL}
                            alt="Profile"
                        />
                        }
                        onClick={onClick}
                        isSelected={isOpen}
                        tooltip={"User Menu"}
                        {...triggerProps}
                    />
                )}
            />
        );
    };

    accountBarTheme = generateTheme({
        name: 'atlassian',
        backgroundColor: '#0052CC',
        highlightColor: '#FFFFFF',
    });


    graphqlHome = () => (
        <CustomProductHome
            iconAlt="GraphQL-Gateway"
            iconUrl={smallIconURL}
            logoAlt="GraphQL-Gateway"
            logoUrl={largeIconURL}
            siteTitle={`${this.props.accountName}`}
        />
    );

    signIn = () => (
        <SignIn onClick={this.props.handleLoginAuth} tooltip="Login">Login</SignIn>
        );

    render() {
        return (
            <AtlassianNavigation
                className="top-bar"
                label="site"
                renderProductHome={this.graphqlHome}
                renderProfile={this.props.accountTemplate ? (this.props.signedIn ? this.userProfile : undefined) : undefined}
                renderSignIn={this.props.accountTemplate ? (this.props.signedIn ? undefined: this.signIn) : undefined}
                theme={this.accountBarTheme}
            >
            </AtlassianNavigation>
        )
    }



}